// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"dbe7c701","239":"cbc94f61","455":"7047f7e6","646":"e2b0b211","977":"ee00509d"}[chunkId] + ".chunk.js";
};